import { render } from "./my_queue.html?vue&type=template&id=d73cc888&external"
import script from "./my_queue.js?vue&type=script&lang=js&external"
export * from "./my_queue.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__